import React, { useState, Fragment } from 'react';
import {
    Row,
    Input,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI } from '../../../../../../helpers/AxiosAPI';
import { putAPI_Update_Property_images } from '../../../../../../constants/APIs';
import ImageGallery from '../../gallery/index'
import IntlMessages from '../../../../../../helpers/IntlMessages';

export const PropertyImage = ({ visible, toggle, images, propertyId }) => {
    const [propertyImages, setPropertyImages] = useState(images || [{ caption: '', url: '', priority: '', videoUrl: '' }]);
    const [galleryVisible, setGalleryVisible] = useState(false);
    const [imageIndex, setImageIndex] = useState(-1);
    const handleChange = (e, index) => {
        e.persist();
        const newItems = [...propertyImages];
        newItems[index][e.target.name] = e.target.value;
        setPropertyImages(newItems);
    };

    const deleteImage = (index) => {
        let newImages = propertyImages.length > 1 ? propertyImages.filter((item, j) => (index !== j)) : propertyImages;
        setPropertyImages(newImages);
    };

    const addImage = () => {
        setPropertyImages(propertyImages.concat({ caption: '', url: '', priority: '1', videoUrl: '' }));
    };

    const togglegallery = (index) => {
        setImageIndex(index)
        setGalleryVisible(!galleryVisible);
    };

    const selectedImage = (image) => {
        const newItems = [...propertyImages];
        newItems[imageIndex].url = image.src;
        newItems[imageIndex].caption = image.caption;
        setPropertyImages(newItems);
    };

    const handlePropertyImage = async () => {
        let data = { id: propertyId, images: propertyImages, updater: 'Test123' };
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_Property_images}/${propertyId}`,
            data: data,
        }).then(res => {
            setTimeout(() => {
                window.location.reload();
            }, 300)
        })
            .catch(err => {
                console.log('err', err);
            });
    }
    const ImageGalleryButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={galleryVisible} toggle={togglegallery} style={{ maxWidth: '1000px' }}>
                                <ModalHeader toggle={togglegallery}>
                                    Select Image or Upload New Image
                                </ModalHeader>
                                <ModalBody>
                                    <ImageGallery selectedImage={selectedImage} togglegallery={togglegallery}
                                        hideUserUploads={false} searchText={""} />
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle} style={{ maxWidth: '1000px' }}>
                <ModalHeader toggle={toggle}>
                    Property Images
                </ModalHeader>
                <ModalBody>
                    <Row>
                        {propertyImages.length > 0 && propertyImages.map((image, index) => (
                            <Fragment key={index}>
                                <Colxx sm={2} className="md-3">
                                    <img
                                        style={{
                                            width: '100%',
                                            height: '90%',
                                        }}
                                        alt="room image"
                                        src={image.url || 'https://via.placeholder.com/150/'}
                                    />
                                </Colxx>
                                <Colxx sm={2} className="mb-3">
                                    <Label>Caption</Label>
                                    <Input
                                        type="text"
                                        name="caption"
                                        value={image.caption}
                                        onChange={event => handleChange(event, index)}
                                    />
                                </Colxx>

                                <Colxx sm={2} className="mb-3">
                                    <Label><IntlMessages id='dashboards.displayOrder' /> </Label>
                                    <Input
                                        type="number"
                                        name="priority"
                                        min={1}
                                        value={image.priority}
                                        onChange={event => handleChange(event, index)}
                                    />
                                </Colxx>
                                <Colxx sm={4} className="mb-3">
                                    <Label>Video Link</Label>
                                    <Input
                                        type="text"
                                        name="videoUrl"
                                        value={image.videoUrl}
                                        onChange={event => handleChange(event, index)}
                                    />
                                </Colxx>
                                <Colxx sm={1} className="mb-3">
                                    <Label>Browse</Label>
                                    <div className="iconsminds-photo" onClick={event => togglegallery(index)}
                                        style={{ cursor: 'pointer', fontSize: '28px', color: '#73236b' }}
                                    >

                                    </div>
                                </Colxx>
                                <Colxx sm={1} className="mb-3">
                                    <Label>Remove</Label>
                                    <div>
                                        <Button
                                            onClick={() => deleteImage(index)}
                                            color="secondary"
                                            size="xs"
                                            outline
                                            style={{ margin: '6px' }}
                                        >
                                            -
                                        </Button>
                                    </div>
                                </Colxx>
                            </Fragment>
                        ))}
                    </Row>
                    <Button
                        onClick={addImage}
                        color="primary"
                        size="xs"
                        outline
                        style={{ margin: '6px' }}
                    >
                        + <IntlMessages id='dashboards.addImages' />
                    </Button>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handlePropertyImage}>
                        <IntlMessages id='dashboards.save' />
                    </Button>
                    <Button color="secondary" onClick={toggle}>
                        <IntlMessages id='pages.cancel' />
                    </Button>
                </ModalFooter>
            </Modal>
            {ImageGalleryButton()}
        </Fragment>
    );
};

export default PropertyImage;